import { Struct } from 'contexts/structs/types/types'
import { Button } from 'opensolar-ui'
import { PromoDialogView } from 'persistentContent/promoDialog/PromoDialogView'
import { OpenSolarVersionInfo } from 'persistentContent/promoDialog/useOpenSolarVersionStructs'
import { PromoDialog } from 'persistentContent/promoDialog/usePromoDialogStructs'
import { useState } from 'react'
import { useFormState } from 'react-final-form'
import { doNotTranslate } from 'util/misc'
import { OpenSolarVersionStructPreview } from './OpenSolarVersionStructPreview'

// Show some struct-type specific UI here
export const StructCustomUI = () => {
  const formValues = useFormState<Struct<PromoDialog | OpenSolarVersionInfo>>().values
  const structType = formValues.type

  const [open, setOpen] = useState(false)

  switch (structType) {
    case 'opensolar-version':
      return <OpenSolarVersionStructPreview data={formValues.data as OpenSolarVersionInfo} />

    case 'promo-dialog': {
      const promoData = formValues.data as PromoDialog
      const blocker = promoData.type === 'blocker'
      return (
        <>
          <PromoDialogView
            elements={promoData.elements}
            open={open}
            backEnabled={false}
            nextEnabled={true}
            onCloseComplete={() => setOpen(false)}
            showActionsBar={!blocker}
            showPagination={!blocker}
            totalPages={3}
            currentPage={1}
            nextWillClose={true}
            onBack={() => {}}
            onNext={() => setOpen(false)}
            onBackdropClick={() => setOpen(false)}
          />
          <Button variant="contained" onClick={() => setOpen(!open)}>
            {doNotTranslate('Preview')}
          </Button>
        </>
      )
    }

    default:
      return <></>
  }
}
